import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** className helper that resolves Tailwind class conflicts (later wins). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
